var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShipping = function SvgShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shipping_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shipping_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13.333a1.929 1.929 0 0 1-1.417-.583A1.929 1.929 0 0 1 2 11.333H.667V4c0-.367.13-.68.391-.942.261-.26.575-.391.942-.391h9.333v2.666h2l2 2.667v3.333H14c0 .556-.195 1.028-.584 1.417a1.93 1.93 0 0 1-1.416.583 1.929 1.929 0 0 1-1.417-.583A1.929 1.929 0 0 1 10 11.333H6c0 .556-.195 1.028-.583 1.417A1.929 1.929 0 0 1 4 13.333ZM4 12a.645.645 0 0 0 .475-.192.645.645 0 0 0 .192-.475.645.645 0 0 0-.192-.475.645.645 0 0 0-.475-.191.645.645 0 0 0-.475.191.645.645 0 0 0-.192.475c0 .19.064.348.192.475A.645.645 0 0 0 4 12Zm-2-2h.533c.19-.2.406-.361.65-.483A1.8 1.8 0 0 1 4 9.333c.3 0 .572.061.816.184.245.122.462.283.65.483H10V4H2v6Zm10 2a.645.645 0 0 0 .475-.192.645.645 0 0 0 .191-.475.645.645 0 0 0-.191-.475.645.645 0 0 0-.475-.191.645.645 0 0 0-.475.191.645.645 0 0 0-.192.475c0 .19.064.348.192.475A.645.645 0 0 0 12 12Zm-.667-3.333h2.833l-1.5-2h-1.333v2Z",
    fill: "#404040"
  }))));
};
export default SvgShipping;